export default __webpack_public_path__ + "static/media/Classwin_Menu-pop-up_7-Information.37202d01.jpeg";